import styled from 'styled-components';
import { th } from 'style/theme';

export const SignatureCanvas = styled.div`
  > canvas {
    width: 100%;
    height: 100%;
    cursor: crosshair;
    border-bottom: 2px dashed ${th('colors.silverChaliceGrey')};
  }
`;

export const Buttons = styled.div`
  margin-top: 8px;
  align-self: flex-end;

  > :first-child {
    margin-right: 12px;
  }
`;
